import { CookieConsent } from "react-cookie-consent";
import { Paragraph } from "../../components/Text";
import { useState } from "react";
import { CookiesNotice } from "./CookiesNotice";


const CookiesConsent = () => {
    const [ expanded, setExpanded ] = useState(false);
    return <CookieConsent
                cookieName="spCookie"
                location="center"
                flipButtons={true}
                buttonText="I agree"
                buttonStyle={{
                    color: "#FFFFFF",
                    background: "var(--sp-main-color)",
                    borderRadius: "4px",
                    margin: 0
                }}
                enableDeclineButton
                declineButtonStyle={{
                    color: "var(--sp-main-color)",
                    background: "transparent",
                    borderRadius: "4px",
                    marginRight: "12px"
                }}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "50%",
                    maxHeight: "450px",
                    backgroundColor: "#FFFFFF",
                    padding: "22px 32px",
                    borderRadius: "8px",
                    boxShadow: "0px 16px 48px rgba(116, 151, 208, 0.1)",
                    left: "calc(100vw - 50% - 24px)",
                    bottom: "24px",
                    color: "var(--sp-text-color)"
                }}
            >
                {
                    expanded
                        ? <CookiesNotice />
                        : <>
                            <Paragraph>We utilize cookies to improve the user experience and to help make the website better serve our visitors. By using our website, you agree to the use of cookies.</Paragraph>
                            <Paragraph>Find out more about cookies in our recently updated <a onClick={() => setExpanded(true)}>Privacy Policy</a> (please read it to stay up to date with our practices regarding the information you provide).</Paragraph>
                        </>
                }
            </CookieConsent>
}

export { CookiesConsent }